import * as React from 'react'
import styled from 'styled-components'
import * as t from './types'
import ImageTeaserMolecule from 'theme/molecules/ImageTeaser'
import useArrowNavigation from 'hooks/useSliderArrowNavigation'

import theme from 'theme'
import EecTracking from 'theme/atoms/EecTracking'
import SliderButton from 'theme/atoms/SliderButton'
import useTranslations from 'hooks/useTranslations'
import withTranslations from './withTranslations'

export function TeaserSlider(props: t.Props) {
  const {
    lastItemRef,
    firstItemRef,
    productListRef,
    lastItemReached,
    firstItemReached,
    handleSlide
  } = useArrowNavigation(() => {
    const container = productListRef.current?.querySelector('.TeaserContainer')
    if (!container) return 0
    const width = container.getBoundingClientRect().width
    return width + 20
  })
  const t = useTranslations<'organisms-TeaserSlider'>()

  return (
    <EecTracking config={props.eecTracking} gridArea={props.gridArea}>
      <Wrapper className="TeaserSlider" data-cy-ctx={'organisms/TeaserSlider'}>
        <div className={'innerSlider'} ref={productListRef}>
          <div ref={firstItemRef} className={'firstLast'}>
            &#160;
          </div>
          {props.items.map((item, i) => (
            <TeaserContainer
              className="TeaserContainer"
              $isLast={i === props.items.length - 1}
              key={i}
            >
              <ImageTeaserMolecule
                imgSrc={props.context.optImages[i]}
                link={item.link}
                linkLabel={item.linkLabel}
                description={item.description}
                title={item.title}
              />
            </TeaserContainer>
          ))}
          {!firstItemReached && (
            <SliderButton
              facing="left"
              title={t.asText(false, 'teaser_slider_prev_button_title')}
              onClick={() => handleSlide('left')}
              data-cy-handle="prev-button"
              data-cy-state="has-prev-button"
            />
          )}
          {!lastItemReached ? (
            <SliderButton
              facing="right"
              title={t.asText(false, 'teaser_slider_next_button_title')}
              onClick={() => handleSlide('right')}
              data-cy-handle="next-button"
              data-cy-state="has-next-button"
            />
          ) : null}
          <div ref={lastItemRef} className={'firstLast'}>
            &#160;
          </div>
        </div>
      </Wrapper>
    </EecTracking>
  )
}
export default withTranslations(TeaserSlider)

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  height: 28rem;
  @media (min-width: ${theme.ms.MD}px) {
    height: 30.5rem;
  }
  .innerSlider {
    display: flex;
    overflow-x: auto;
    scrollbar-width: none;
    align-items: center;

    &::-webkit-scrollbar {
      width: 0;
      background: transparent;
    }

    > .firstLast {
      width: 1px;
      align-self: center;
    }
  }
`

const TeaserContainer = styled.div<{ $isLast: boolean }>`
  width: 100%;
  max-width: 62.5rem;
  flex-shrink: 0;
  height: 100%;
  margin-right: ${(p) => (p.$isLast ? 0 : theme.spacing('m'))};
`
